import { watch, onUnmounted, computed } from 'vue';

/**
 * 控制 body 的 modal-open 类，用于锁住背景滚动
 * @param {import('vue').Ref<boolean>} visible - 控制弹窗/抽屉显示状态的 ref
 */
export function useModalScrollLock(visible) {
	if (!visible) {
		console.warn('useModalScrollLock: visible 参数是必需的');
		return;
	}

	const innerVisible = computed(() => visible.value);

	// 更新 body 的 modal-open 类
	const updateBodyClass = isVisible => {
		if (isVisible) {
			document.body.classList.add('modal-open');
		} else {
			document.body.classList.remove('modal-open');
		}
	};

	// 监听 visible 变化
	watch(
		() => innerVisible.value,
		newValue => {
			updateBodyClass(newValue);
		},
		{ immediate: true }
	);

	// 组件卸载时清理
	onUnmounted(() => {
		document.body.classList.remove('modal-open');
	});
}
